import React from "react";
import "./PageNotFound.css";
import { Link } from "react-router-dom";
import { Button } from "@mui/material";

export default function PageNotFound() {
  return (
    <div>
      <section className="page_404">
        <div className="container">
          <div className="row">
            <div className="col-sm-12 ">
              <div className="col-sm-10 col-sm-offset-1  text-center">
                <div className="four_zero_four_bg">
                  <h1 className="text-center ">404</h1>
                </div>

                <div className="contant_box_404">
                  <h3 className="h2">Oops! Page not found</h3>
                  <p>We can't seem to find the page you're looking for.</p>
                  <Link to="/">
                    <Button
                      variant="contained"
                      sx={{
                        backgroundColor: "#510d10",
                        color: "white",
                        "&:hover": {
                          backgroundColor: "#510d10",
                        },
                      }}
                    >
                      Go to Home
                    </Button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
